import React from 'react';

import {useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {Notifications, StackContainer} from './styles';
import {NotificationStatusProps} from '../types';

export function NotificationStatus({
	messageQuantity,
	isNotificationsEnabled,
}: NotificationStatusProps) {
	const {colors} = useTheme();

	return (
		<StackContainer direction="row" gap={1}>
			<Icon name="dialog-filled" color={colors.brand.primary.blue} />

			<Notifications $isNotificationsEnabled={isNotificationsEnabled}>
				{messageQuantity}
			</Notifications>
		</StackContainer>
	);
}
